<template>
    <data-table
        :customizeTable="{
            labelLoading: 'Chargement...',
            labelDetails: ''
        }"
        :loading="loading"
        :data="subscriptions"
        :headers="columns">
        <template #withPerPage>
            <with-per-page
                :customizeTable="{
                    labelShowing: '',
                    labelEntries: '',
                    entries: [10, 15, 20, 25, 30]
                }"
                @makeSelected="makeSelected($event)"
            />
        </template>

        <template #withPagination>
            <with-pagination
                @previous="previous()"
                @next="next()"
                :links="links"
            />
        </template>

        <template #withSearch>
            <button @click="exportData()" class="btn btn-primary" :class="exporting || subscriptions.length === 0 ? 'disabled' : ''">
                <span v-if="exporting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Exporter
            </button>
        </template>

        <template #withBody>
            <tr v-for="(item, i) in subscriptions" :key="i" @click="$router('souscriptions/show/'+item.uuid)" style="cursor:pointer">
                <td>{{ item.id }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.product }}</td>
                <td>{{ $format(item.amount) }}</td>
                <td>{{ item.treat_name }}</td>
                <td>{{ item.inter_name }}</td>
                <td>{{ item.created_at }}</td>
                <td>
                    <span v-if="item.status === 'save'" style="color: #0b2e13" class="badge badge-pill badge-light">Sauvegardé</span>
                </td>
            </tr>
        </template>
    </data-table>
</template>

<script>
    import WithPerPage from "../../../../components/customTable/elements/withPerPage";
    import WithSearch from "../../../../components/customTable/elements/withSearch";
    import WithPagination from "../../../../components/customTable/elements/withPagination";
    import DataTable from "../../../../components/customTable/dataTable";
    import axios from "axios";
    import {_buildQuery, api} from "../../../../helpers/shared";

    const default_customize = {
        labelShowing: 'Show',
        labelEntries: 'entries',
        entries: [10, 15, 20, 25, 30],
        labelSearch: 'Search',
        labelLoading: 'Loading...',
        labelDetails: 'Showing 0 to 0 of 0 entries'
    };

    export default {
        name: "saveSubscription",
        components: {WithPerPage, WithSearch, WithPagination, DataTable},
        props: ['content'],
        data: () => ({
            columns: [
                {title: 'id', key: 'reference'},
                {title: 'client', key: 'name'},
                {title: 'produit', key: 'product'},
                {title: 'montant(Fcfa)', key: 'amount'},
                {title: 'traité par', key: 'treat_name'},
                {title: 'point de vente', key: 'inter_name'},
                {title: 'date', key: 'created_at'},
                {title: 'statut', key: 'status'},
            ],
            loading: false,
            links: [],
            subscriptions: [],
            exporting: false,
            query:{
                page: 1,
                per: 10,
                namespace: 'save',
                product: ''
            }
        }),
        mounted() {
            //this.subscriptions = [ ...this.content.data ];
            console.log("From saveSubscription")
        },
        methods:{
            makeFilter(query){
                this.query = { ...query };
                this.loading = true;
                axios.get(api('load-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },

            exportData(){
                this.exporting = true;
                axios.post(api('administration/subscriptions/export'), this.query).then((response) => {
                    let data = response.data;
                    const worksheet = XLSX.utils.json_to_sheet(data);
                    const workbook = {
                        Sheets: {
                            'data': worksheet
                        },
                        SheetNames: ['data']
                    }
                    XLSX.writeFile(workbook, "result.xlsx");
                    this.exporting = false;
                }).catch((error) => {
                    this.exporting = false;
                    if (error.response.status !== 422){
                        this.$toasted.global.error({message: "Votre connexion a expiré"})
                    }else this.$toasted.global.error({message: "Une erreur est survenu lors de l'exportation"})
                })
            },

            makeSelected(val){
                this.loading = true;
                this.query.per = val;
                axios.get(api('load-subscription'+_buildQuery(this.query)))
                    .then((response) => {
                        let content = response.data;
                        this.subscriptions = content.data;
                        this.loading = false;
                    }).catch((error) => {
                    if (error.response.status === 422){
                        this.loading = false;
                        this.errors = error.response.data.errors
                    }else this.$toasted.global.error({message: "Votre connexion a expiré"})
                })
            },
        }
    }
</script>

<style scoped>

</style>
